<template>
  <div style="padding: 120px 24px 80px 24px; max-width: 800px; margin: 0 auto;">
    <LandingLoader v-if="loading" />
    
    <div v-else class="fetched-content-card">
      <div v-if="fetchedContent" v-html="fetchedContent" class="fetched-content-wrapper"></div>
      
      <div v-else>
        <h1 style="font-size: 36px; margin-bottom: 20px;">Terms & Conditions</h1>
        <p style="color: var(--text-muted); line-height: 1.8;">
          Terms of service and regulations associated with the SARPA Madhya Pradesh network.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import LandingLoader from '../components/LandingLoader.vue';

export default {
  name: 'TermsCondition',
  components: {
    LandingLoader
  },
  data() {
    return {
      loading: true,
      fetchedContent: null
    };
  },
  mounted() {
    axios.get('/content/get/terms_and_condition')
      .then(response => {
        if (response.data && response.data.status && response.data.data && response.data.data.content) {
          this.fetchedContent = response.data.data.content.content;
        }
      })
      .catch(error => {
        console.error('Error fetching Terms & Conditions content:', error);
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>
